import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Apply theme before React renders to avoid any flash.
// This mirrors the logic in ThemeContext : préférence localStorage
// ('rabbit-theme-preference'), 'system' résolu via prefers-color-scheme,
// night par défaut. (FORCE_NIGHT_BETA est false — Day/Night/System actifs.)
(function applyInitialTheme() {
  try {
    const stored = window.localStorage.getItem('rabbit-theme-preference');
    const resolved =
      stored === 'day' || stored === 'night'
        ? stored
        : stored === 'system' &&
            window.matchMedia('(prefers-color-scheme: light)').matches
          ? 'day'
          : 'night';
    document.documentElement.setAttribute('data-theme', resolved);
  } catch {
    // Ignore
  }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
